import { createRouter, createWebHistory } from 'vue-router';
import BlogList from '../components/BlogList.vue';
import BlogPost from '../components/BlogPost.vue';
import AboutMe from '../components/AboutMe.vue';
import ProfessionalExperience from '../components/ProfessionalExperience.vue';
import ContactForm from '../components/ContactForm.vue';
import AdminLogin from '../components/admin/AdminLogin.vue';
import AdminDashboard from '../components/admin/AdminDashboard.vue';
import PostEditor from '../components/admin/PostEditor.vue';


const routes = [
    {
        path: '/',
        name: 'Blog',
        component: BlogList
    },
    {
        path: '/blog/:id',
        name: 'BlogPost',
        component: BlogPost
    },
    {
        path: '/about',
        name: 'AboutMe',
        component: AboutMe
    },
    {
        path: '/experience',
        name: 'ProfessionalExperience',
        component: ProfessionalExperience
    },
    {
        path: '/contact',
        name: 'ContactForm',
        component: ContactForm
    },
    {
        path: '/admin',
        name: 'AdminLogin',
        component: AdminLogin,
        meta: { guest: true }
    },
    {
        path: '/admin/dashboard',
        name: 'AdminDashboard',
        component: AdminDashboard,
        meta: { requiresAuth: true }
    },
    {
        path: '/admin/posts/new',
        name: 'NewPost',
        component: PostEditor,
        meta: { requiresAuth: true }
    },
    {
        path: '/admin/posts/:id/edit',
        name: 'EditPost',
        component: PostEditor,
        props: true,
        meta: { requiresAuth: true }
    }

];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'Ivan Rozhkov';
    
    const isAuthenticated = localStorage.getItem('auth_token') !== null;
    
    if (to.meta.requiresAuth && !isAuthenticated) {
        next({ name: 'AdminLogin' });
    } else if (to.meta.guest && isAuthenticated) {
        next({ name: 'AdminDashboard' });
    } else {
        next();
    }
});

export default router;
